import { render, staticRenderFns } from "./RadarModal.vue?vue&type=template&id=56c62f4c&"
import script from "./RadarModal.vue?vue&type=script&lang=js&"
export * from "./RadarModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports